import { render, staticRenderFns } from "./SpaceVismaSettings.vue?vue&type=template&id=3db2f7f4"
import script from "./SpaceVismaSettings.vue?vue&type=script&lang=js"
export * from "./SpaceVismaSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports